const samples = [
  'LOL_15/1.jpg',
  'LOL_15/22.jpg',
  'LOL_15/23.jpg',
  'LOL_15/55.jpg',
  'LOL_15/79.jpg',
  'LOL_15/111.jpg',
  'LOL_15/146.jpg',
  'LOL_15/179.jpg',
  'LOL_15/493.jpg',
  'LOL_15/547.jpg',
  'LOL_15/665.jpg',
  'LOL_15/669.jpg',
  'LOL_15/748.jpg',
  'LOL_15/778.jpg',
  'LOL_15/780.jpg',
  '5K/a0004-jmac_MG_1384.jpg',
  '5K/a0018-kme_234.jpg',
  '5K/a0028-_DSC0032.jpg',
  '5K/a0029-jmac_DSC3974.jpg',
  '5K/a0048-kme_066.jpg',
  '5K/a0049-_I2E5952.jpg',
  '5K/a0055-050729_194412__I2E5282.jpg',
  '5K/a0066-Ja_Pe-65.jpg',
  '5K/a0094-CRW_2714.jpg',
  '5K/a0097-JI2E5089.jpg',
  '5K/a0104-dvf_003.jpg',
  '5K/a0120-_MG_0300.jpg',
  '5K/a0130-kme_494.jpg',
  '5K/a0137-IMG_4565.jpg',
  '5K/a0148-07-07-16-at-23h50m49s-_MG_2214.jpg',
  '5K/a0160-_DSC0023.jpg',
  '5K/a0165-_MG_1166.jpg',
  '5K/a0171-kme_265.jpg',
  '5K/a0174-NKIM_MG_6678.jpg',
  '5K/a0189-IMG_1799.jpg',
  '5K/a0190-dgw_034.jpg',
  '5K/a0212-IMG_0358.jpg',
  '5K/a0223-050816_115418__MG_4849.jpg',
  '5K/a0233-jn_2007_12_15__BU_CRUISE_248.jpg',
  '5K/a0234-JI2E4685.jpg',
  '5K/a0257-kme_118.jpg',
  '5K/a0260-IMG_3434.jpg',
  '5K/a0265-kme_067.jpg',
  'video/0001.jpg',
  'video/0002.jpg',
  'video/0003.jpg',
  'video/0004.jpg',
  'video/0005.jpg',
];
export default samples;
